import { render } from "./OAList.vue?vue&type=template&id=1e0a24c2&scoped=true"
import script from "./OAList.vue?vue&type=script&lang=js"
export * from "./OAList.vue?vue&type=script&lang=js"

import "./OAList.vue?vue&type=style&index=0&id=1e0a24c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0a24c2"]])

export default __exports__